import { ColorValues, Flex, Typography } from '@banhala/ui-kit';
import React from 'react';
import { getHour, isNil } from 'shared/src/utils';
import Svg, { Path } from 'react-native-svg';

export const TodayDeliveryChip: React.FC<{
  hourStr: string | null;
}> = props => {
  if (isNil(props.hourStr)) return null;
  return (
    <Flex.Row
      backgroundColor={'bg_tertiary'}
      alignItems={'center'}
      justifyContent={'center'}
      borderRadius={2}
      testID={'오늘출발칩'}
    >
      <Flex
        backgroundColor={'lilac40'}
        borderRadius={2}
        padding={{ horizontal: 4, vertical: 4 }}
      >
        <Svg width="38" height="10" viewBox="0 0 38 10" fill="none">
          <Path
            d="M23.205 0.714785H20.355L20.0703 1.7773H22.7303C22.1327 2.32788 20.8832 2.55004 19.7329 2.58868L19.4482 3.6512C20.8911 3.6029 22.2958 3.36142 23.3773 2.64664C24.0687 3.31312 25.3437 3.59324 26.7682 3.6512L27.0529 2.58868C25.9558 2.54038 24.8305 2.2989 24.5003 1.7773H27.1703L27.455 0.714785H24.575L24.7665 0H23.3965L23.205 0.714785Z"
            fill="white"
          />
          <Path
            d="M22.0887 4.9552L21.9749 5.38021H19.1049L18.8279 6.41375H24.5579L24.4518 6.80978H18.7218L18.0618 9.27289H25.3718L25.6514 8.22969H19.7113L19.8175 7.83366H25.5475L26.2049 5.38021H23.3249L23.4387 4.9552H26.8987L27.1886 3.87336H18.9286L18.6387 4.9552H22.0887Z"
            fill="white"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M32.0953 0.415371L31.808 1.48755H29.918L30.2053 0.415371H28.8653L27.7446 4.59783H32.3146L33.4353 0.415371H32.0953ZM29.6307 2.55973H31.5207L31.2619 3.52565H29.3719L29.6307 2.55973Z"
            fill="white"
          />
          <Path
            d="M37.0308 1.99949H35.7608L36.2138 0.30912H34.8438L33.6636 4.71374H35.0336L35.4503 3.1586H36.7202L37.0308 1.99949Z"
            fill="white"
          />
          <Path
            d="M34.2092 8.20073H28.6392L28.766 7.72743H34.226L34.9223 5.12909H28.0923L27.8076 6.19161H33.2676L33.1381 6.67457H27.6782L26.9819 9.27291H33.9219L34.2092 8.20073Z"
            fill="white"
          />
          <Path
            d="M12.5862 1.86423H18.3762L18.0786 2.97504H10.9186L11.62 0.357384H12.99L12.5862 1.86423Z"
            fill="white"
          />
          <Path
            d="M10.1884 3.53528H18.4484L18.1534 4.63644H9.89339L10.1884 3.53528Z"
            fill="white"
          />
          <Path
            d="M10.8883 8.2007H16.8283L16.5411 9.27288H9.23105L9.92469 6.6842H15.6547L15.7737 6.23987H10.0437L10.3284 5.17735H17.4284L16.7426 7.73706H11.0126L10.8883 8.2007Z"
            fill="white"
          />
          <Path
            fillRule="evenodd"
            clipRule="evenodd"
            d="M8.00457 5.00359C8.70363 4.55927 9.21445 3.92176 9.44221 3.07174C9.67256 2.21207 9.50079 1.58422 9.03985 1.13989C8.49961 0.618291 7.5469 0.36715 6.3469 0.36715C5.1469 0.36715 4.06961 0.618291 3.23985 1.13989C2.54079 1.58422 2.03256 2.21207 1.80221 3.07174C1.57445 3.92176 1.74363 4.55927 2.20457 5.00359C2.65328 5.41894 3.34857 5.66042 4.23787 5.7377L3.72799 7.64057H0.307995L0 8.79002H8.16L8.46799 7.64057H5.08799L5.59787 5.7377C6.51857 5.66042 7.34328 5.41894 8.00457 5.00359ZM7.85691 2.00922C8.10962 2.26036 8.19903 2.59844 8.07221 3.07174C7.94797 3.53539 7.67739 3.87346 7.2901 4.1246C6.75951 4.46268 6.02069 4.60756 5.21069 4.60756C4.40069 4.60756 3.73951 4.46268 3.3901 4.1246C3.13739 3.87346 3.04798 3.53539 3.17221 3.07174C3.29903 2.59844 3.56962 2.26036 3.95691 2.00922C4.4875 1.67115 5.22632 1.52626 6.03632 1.52626C6.84632 1.52626 7.5075 1.67115 7.85691 2.00922Z"
            fill="white"
          />
        </Svg>
      </Flex>
      <Flex padding={{ horizontal: 4, vertical: 2 }}>
        <Typography rawColor={ColorValues.lilac40} type={'subtitle6'}>
          ~{getHour(props.hourStr).format('HH')}시 주문시
        </Typography>
      </Flex>
    </Flex.Row>
  );
};
